package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.staffing.LabourTarget
import com.evoapps.evoshift.domain.model.GeoLocation
import com.evoapps.evoshift.domain.model.WorkplaceFinancials
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class UpdateWorkplaceLocationUseCase(private val repository: WorkplaceRepository) {
    /** Saves the address and the point, rounded to [GeoLocation.DECIMALS] places (about 11 cm). */
    suspend operator fun invoke(workplaceId: String, address: String, location: GeoLocation?): Result<Unit> {
        return repository.updateWorkplaceLocation(workplaceId, address.trim(), location?.rounded())
    }
}

class UpdateWorkplaceFinancialsUseCase(private val repository: WorkplaceRepository) {
    suspend operator fun invoke(
        workplaceId: String,
        financials: WorkplaceFinancials
    ): Result<Unit> {
        // SH-54: the labour target is a share of sales in percent (or absent: the market's default).
        val labour = financials.labourTargetPercent
        if (labour != null && labour !in LabourTarget.MIN_PERCENT..LabourTarget.MAX_PERCENT) {
            return Result.failure(IllegalArgumentException("The labour target must be between ${LabourTarget.MIN_PERCENT} and ${LabourTarget.MAX_PERCENT}%"))
        }
        // SH-120: the sales-per-labour-hour goal is positive, or absent (the workplace's own figure).
        val perHour = financials.salesPerLabourHourGoal
        if (perHour != null && perHour <= 0) {
            return Result.failure(IllegalArgumentException("The sales per labour hour goal must be above zero"))
        }
        return repository.updateWorkplaceFinancials(workplaceId, financials)
    }
}
